// removed by extract-text-webpack-plugin
module.exports = {"requirements":"requirements--2QS9R","title":"title--LB8Rb"};